<form class="form-inline">
		<div class="search-input-wrapper">
			<label for="field-value" class="sr-only">{{locale "searchValue"}}</label>
			{{#if control}}
				<select id="field-value" name="field-value" class="form-control" style="display:inline-block">
					<option value="{{value}}">{{label}}</option>
				</select>
			{{else}}
				<input type="text" id="field-value" name="field-value" value="{{ value }}" class="form-control"/>
			{{/if}}
		</div>
    <button type="button" class="close" data-control="removeFilter" >{{icon name="close" locale="clearFilter"}}</button>
	<button type="submit" name="submit" class="btn btn-sm btn-primary" {{#unless serverSideEnum}}disabled="disabled"{{/unless}}>{{locale "apply"}}</button>
	<button type="button" name="clear" class="btn btn-sm btn-tertiary btn-clear-filter hidden">{{locale "clear"}}</button>
</form>
